import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import LandingPage from "@/pages/LandingPage";
import SetupPage from "@/pages/SetupPage";
import DashboardPage from "@/pages/DashboardPageSimple"; // Simple version works!

function App() {
  return (
    <LanguageProvider>
      <div className="min-h-screen bg-background">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/setup" element={<SetupPage />} />
            <Route path="/dashboard/:groupId" element={<DashboardPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" theme="dark" />
      </div>
    </LanguageProvider>
  );
}

export default App;
